import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.regexp.to-string";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/data/landun/workspace/vft-activities/d2d-welfare/codebase/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js";
import _defineProperty from "/data/landun/workspace/vft-activities/d2d-welfare/codebase/node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import BumpModal from "../BumpModal/BumpModal.vue";
import { mapState } from 'vuex';
import { executeOneInTime, bus } from '@tencent/vft-vue-base';
import { RequestLogicError } from '@tencent/Coa';
import VipIcon from '@tencent/vft-ui/src/VipIcon/VipIcon.vue';
var BumpState = {
  CanBump: '能碰',
  Bumped: '已经碰过',
  NoEgg: '没蛋了',
  NoChance: '主人没蛋了',
  Invalid: '过期了'
};
var PersonalCodeStatus = {
  Valid: 0,
  Invalid: 1
};
export default {
  name: 'Bump',
  components: {
    BumpModal: BumpModal,
    VipIcon: VipIcon
  },
  settingKey: '碰蛋弹窗',
  setting: {
    按钮: {
      type: 'object',
      properties: {
        不想碰: 'https://puui.qpic.cn/vupload/0/20190624_1561362311991_ulfgj3rbzn.png/0',
        和TA碰: 'https://puui.qpic.cn/vupload/0/20190624_1561362309663_eablgoznavo.png/0',
        算了: 'https://puui.qpic.cn/vupload/0/20190624_1561379109634_gl5ogwys7d8.png/0',
        做任务加蛋: 'https://puui.qpic.cn/vupload/0/20190624_1561379105730_8xq937kq4xk.png/0',
        知道了: 'https://puui.qpic.cn/vupload/0/20190624_1561379114426_8dm84ngtzjg.png/0'
      }
    },
    提示文案: {
      type: 'object',
      properties: {
        能碰: {
          type: 'object',
          properties: {
            主标题: '有机会碰出Play Station 4 游戏主机',
            副标题: {
              type: 'expression',
              default: '今日剩余${egg_count}个${egg_name}',
              variables: ['egg_count', 'egg_name']
            }
          }
        },
        没蛋了: {
          type: 'object',
          properties: {
            主标题: '糟糕，今天没有蛋了呦~',
            副标题: ''
          }
        },
        主人没蛋了: {
          type: 'object',
          properties: {
            主标题: '您手速太慢了，蛋被别人碰了哦~',
            副标题: '赶紧去找其他小伙伴对对碰吧'
          }
        },
        已经碰过: {
          type: 'object',
          properties: {
            主标题: '今日你已跟TA碰过啦',
            副标题: '赶紧去找其他小伙伴对对碰吧'
          }
        },
        过期了: {
          type: 'object',
          properties: {
            主标题: 'Ta昨天的蛋已经被回收啦',
            副标题: '赶紧去找今天的蛋碰大奖吧'
          }
        }
      }
    },
    peng: 'https://puui.qpic.cn/vupload/0/20190620_1561103042675_moigs634cr.png/0',
    vs: 'https://puui.qpic.cn/vupload/0/20190624_1561361416061_k8azq9tp1cd.png/0',
    没蛋了: 'https://puui.qpic.cn/vupload/0/20190624_1561431266699_kpd0glp11s.png/0',
    休息中: 'https://puui.qpic.cn/vupload/0/20190705_1562643524557_90fyz1a47e6.png/0',
    失效了: 'https://puui.qpic.cn/vupload/0/20190705_1562915923452_2xa3q54i9x1.png/0'
  },
  computed: _objectSpread(_objectSpread({}, mapState('bump', ['myEggInfo', 'shareCodeInfo', 'masterEggInfo', 'masterUserInfo'])), {}, {
    bumpState: function bumpState() {
      if (this.shareCodeInfo.personal_code_status === PersonalCodeStatus.Invalid) {
        return BumpState.Invalid;
      } else if (this.shareCodeInfo.is_today_collision) {
        return BumpState.Bumped;
      } else if (this.masterEggInfo.eggs_count === 0) {
        return BumpState.NoChance;
      } else if (this.myEggInfo.egg_count > 0) {
        return BumpState.CanBump;
      } else {
        return BumpState.NoEgg;
      }
    },
    singleEggStyle: function singleEggStyle() {
      return this.bumpState !== BumpState.CanBump && this.bumpState !== BumpState.NoEgg;
    },
    hintText: function hintText() {
      var res = this.setting.提示文案[this.bumpState];

      if (typeof res.副标题 === 'function') {
        return {
          主标题: res.主标题,
          副标题: res.副标题(this.myEggInfo)
        };
      } else {
        return res;
      }
    },
    statusImg: function statusImg() {
      if (this.bumpState === BumpState.NoEgg || this.bumpState === BumpState.NoChance) {
        return this.setting.没蛋了;
      } else if (this.bumpState === BumpState.Invalid) {
        return this.setting.失效了;
      } else if (this.bumpState === BumpState.Bumped) {
        return this.setting.休息中;
      } else {
        return null;
      }
    },
    buttons: function buttons() {
      var btnImgs = this.setting.按钮;

      switch (this.bumpState) {
        case BumpState.CanBump:
          return {
            left: btnImgs.不想碰,
            leftAction: this.cancel,
            leftReport: this.reportData.碰蛋弹框.不想碰,
            right: btnImgs.和TA碰,
            rightAction: this.bump,
            rightReport: this.reportData.碰蛋弹框.和TA碰
          };

        case BumpState.NoEgg:
          return {
            left: btnImgs.算了,
            leftAction: this.cancel,
            leftReport: this.reportData.碰蛋弹框.算了,
            right: btnImgs.做任务加蛋,
            rightAction: this.goToTask,
            rightReport: this.reportData.碰蛋弹框.做任务加蛋
          };

        default:
          return {
            left: btnImgs.知道了,
            leftAction: this.cancel,
            leftReport: this.reportData.碰蛋弹框.我知道了
          };
      }
    },
    leftEgg: function leftEgg() {
      return this.masterEggInfo.egg_skin_url;
    },
    rightEgg: function rightEgg() {
      return this.myEggInfo.egg_skin_url;
    }
  }),
  mounted: function mounted() {
    this.$reportModule({
      f_resource: '碰蛋弹框曝光',
      f_module: '碰蛋弹框',
      f_ext: this.masterUserInfo.master_id
    });
  },
  methods: {
    bump: executeOneInTime( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var award, res;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return this.$store.dispatch('bump/bumpEgg');

            case 3:
              award = _context.sent;
              this.$emit('bumpSuccess', award);
              _context.next = 10;
              break;

            case 7:
              _context.prev = 7;
              _context.t0 = _context["catch"](0);

              if (_context.t0 instanceof RequestLogicError) {
                res = _context.t0.res;

                if (res.ret === -1013) {
                  // 客人蛋不足
                  this.myEggInfo.egg_count = 0;
                  this.$emit('refreshInfo');
                } else if (res.ret === -1014) {
                  // 主人蛋不足
                  this.masterEggInfo.eggs_count = 0;
                  this.$emit('refreshInfo');
                } else if (res.ret === -1018) {
                  this.alert('蛋迷路了~请稍后再来！');
                } else if (res.ret === -1019) {
                  this.alert('手速太慢没碰到，摩拳擦掌再试一次！');
                } else if (res.ret === -1021) {
                  this.alert('系统检测到您的账号存在安全风险。');
                } else {
                  this.alert(_context.t0.toString());
                }
              } else {
                console.error(_context.t0);
                this.alert('活动太火爆，请稍后重试');
              }

            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this, [[0, 7]]);
    }))),
    cancel: function cancel() {
      this.$emit('hide');
    },
    goToTask: function goToTask() {
      this.$emit('hide');
      bus.$emit('gotoTask');
    }
  }
};